import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
// @mui
import { Link, Stack, IconButton, InputAdornment, TextField, Checkbox, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import Iconify from '../../../components/iconify';
import { useAppContext } from '../../../context'

const API_URL = process.env.REACT_APP_API_URL || 'https://api.ginoboxingstudio.com';

// ----------------------------------------------------------------------

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function ResetForm() {
  const navigate = useNavigate();
  const {user, setUser} = useAppContext();
  const query = useQuery();

  const [showPassword, setShowPassword] = useState(false);
  const [passwordConf, setPasswordConf] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    if (user) {
      navigate('/dashboard', { replace: true });
    }
  }, [])

  const handleClick = () => {

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      redirect: 'follow',
      body: JSON.stringify({
        code: query.get("code"), // code contained in the reset link of step 3.
        password,
        passwordConfirmation: passwordConf,
      })
    };

    fetch(`${API_URL}/api/auth/reset-password`, requestOptions)
      .then(response => response.json())
      .then(result => {
        if (result.error) {
          alert('Mot de passe incorrect')
        } else {
          setUser(result)
          navigate('/dashboard', { replace: true });
        }
console.log(result);
      })
      .catch(error => alert('Mot de passe incorrect')
      );

    // navigate('/dashboard', { replace: true });
  };

  return (
    <>
      <Stack spacing={3}>

        <TextField
          sx={{mt: 4}}
          name="password"
          label="Mot de passe"
          value={password} onChange={(event) => (setPassword(event.target.value))} 
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <TextField
          name="password"
          label="Confirmer mot de passe"
          value={passwordConf} onChange={(event) => (setPasswordConf(event.target.value))} 
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>

      {/* <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
        <Link variant="subtitle2" underline="hover">
          Mot de passe oublié?
        </Link>
      </Stack> */}

      <LoadingButton sx={{ my: 2 }} fullWidth size="large" type="submit" variant="contained" onClick={handleClick}>
        Connexion
      </LoadingButton>
    </>
  );
}
